<template>
    <div class="feedback-container right-0 bottom-0 max-w-full lg:max-w-1/4">
        <div v-for="box in feedbackBoxes" :key="box.id">
            <FeedbackBox :id="box.id" :alert-data="box.data" v-on:closeFeedback="removeBox(box.id)"></FeedbackBox>
        </div>
    </div>
</template>

<script>
    import FeedbackBox from './Feedback';

    export default {
        data() {
            return {
                feedbackBoxes: [],
            }
        },
        created() {
            window.events.$on('feedback', data => {
                this.addBox(data);
            });
        },

        methods: {
            addBox(data) {
                let b=a=>a?(a^Math.random()*16>>a/4).toString(16):([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,b);
                let id = b();
                this.feedbackBoxes.push({id: id, data: data});
            },

            removeBox(id) {
                // console.log('closing', id);
                let index = this.feedbackBoxes.map(obj=>obj.id).indexOf(id);
                this.feedbackBoxes.splice(index, 1);
            },
        },

        components: {
            FeedbackBox
        }
    };
</script>

<style lang="scss">
    .feedback-container {
        z-index: 5000;
    }
</style>
